import { useEffect, useState } from "react";
import { fetchFixturesByGameweek, fetchFPLData } from "../api/fplApi";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Live = ({ compact = false }) => {
  const [fixtures, setFixtures] = useState([]);
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeGW, setActiveGW] = useState(null);

  const loadGw = async (gw) => {
    setLoading(true);
    try {
      const data = await fetchFixturesByGameweek(gw);
      setFixtures(data || []);
      setActiveGW(gw);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      const fpl = await fetchFPLData();
      if (!fpl) { setLoading(false); return; }
      setTeams(fpl.teams || []);
      const current = fpl.events?.find((e) => e.is_current)?.id || fpl.events?.find((e) => e.is_next)?.id || 1;
      await loadGw(current);
    };
    init();
  }, []);

  const team = (id) => teams.find((t) => t.id === id) || {};
  const kit = (id) => `https://fantasy.premierleague.com/dist/img/shirts/standard/shirt_${team(id).code}-220.webp`;
  const time = (value) => value ? new Date(value).toLocaleString(undefined, { month:"short", day:"numeric", hour:"2-digit", minute:"2-digit" }) : "";

  return (
    <div>
      <div className="flex justify-end items-center mb-3">
        <div className="fpl-gw-nav">
          <button disabled={activeGW <= 1 || loading} onClick={() => loadGw(activeGW - 1)}><FaChevronLeft /></button>
          <span>GW {activeGW || "—"}</span>
          <button disabled={activeGW >= 38 || loading} onClick={() => loadGw(activeGW + 1)}><FaChevronRight /></button>
        </div>
      </div>

      {loading ? (
        <div className="fpl-empty">Loading fixtures…</div>
      ) : !fixtures.length ? (
        <div className="fpl-empty">No fixtures available for this Gameweek.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5">
          {fixtures.map((f) => {
            const home = team(f.team_h), away = team(f.team_a);
            const status = f.finished ? "FT" : f.started ? "LIVE" : "UPCOMING";
            return (
              <div key={f.id} className="fpl-fixture-row">
                <div className="fpl-fixture-team left"><span>{home.short_name || home.name}</span><img src={kit(f.team_h)} alt="" /></div>
                <div className="fpl-fixture-score">
                  <strong>{f.team_h_score ?? "–"} <span>:</span> {f.team_a_score ?? "–"}</strong>
                  <span className={`fpl-match-status ${status.toLowerCase()}`}>{status}</span>
                  <small>{time(f.kickoff_time)}</small>
                </div>
                <div className="fpl-fixture-team"><img src={kit(f.team_a)} alt="" /><span>{away.short_name || away.name}</span></div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
export default Live;
